import axios from "axios";

let timeoutCallbacks = null;

export const setTimeoutResetCallback = (callbacks) => {
    timeoutCallbacks = callbacks;
};


axios.interceptors.request.use(
    config => {
        // Pause session timeout during API calls
        if (timeoutCallbacks?.pauseTimeout) {
            timeoutCallbacks.pauseTimeout();
        }
         
        const token = sessionStorage.getItem('Token');
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        } 
        return config;
    },
    error => {
        Promise.reject(new Error(error));
    }
);


axios.interceptors.response.use((response) => { // block to handle success case
    // Resume session timeout after API completes
    if (timeoutCallbacks?.resumeTimeout) {
        timeoutCallbacks.resumeTimeout();
    }
    return response
}, function (error) { // block to handle error case
    // Resume session timeout after API error
    if (timeoutCallbacks?.resumeTimeout) {
        timeoutCallbacks.resumeTimeout();
    }
    console.log("Interceptor Error", error)

    return Promise.reject(error)
});

const originalFetch = window.fetch;
window.fetch = function (...args) {
    let [url, options = {}] = args;
    // Pause session timeout during API calls
    if (timeoutCallbacks?.pauseTimeout) {
        timeoutCallbacks.pauseTimeout();
    }

    return originalFetch(url, options)
        .then(response => {
            // Resume session timeout after API completes
            if (timeoutCallbacks?.resumeTimeout) {
                timeoutCallbacks.resumeTimeout();
            }
            return response;
        })
        .catch(error => {
            // Resume session timeout after API error
            if (timeoutCallbacks?.resumeTimeout) {
                timeoutCallbacks.resumeTimeout();
            }
            return Promise.reject(error)

        });
};
